import { render } from "./App.vue?vue&type=template&id=fe23c20e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fe23c20e&lang=scss"
script.render = render

export default script